import { dotToCommaTransform } from "@/lib/formatters/NumericTextFieldInputCleaner";
import {
  createColumnConfig,
  StandardTableConfigWithGroups,
} from "@stenajs-webui/grid";
import { renderHeadingCenter } from "../lib/customer-table-utils";

export interface ThreeYearsVolumeExpectedTableRow {
  routePairCode: string;
  year: number;
  expected: number | null;
  volume: number | null;
  expectedMinus1Year: number | null;
  volumeMinus1Year: number | null;
  expectedMinus2Year: number | null;
  volumeMinus2Year: number | null;
}

export type ThreeYearsVolumeExpectedTableColumn = keyof Omit<
  ThreeYearsVolumeExpectedTableRow,
  "year"
>;

export const threeYearsVolumeExpectedTableConfig = (year: number) => {
  const threeYearsVolumeExpectedTableConfig: StandardTableConfigWithGroups<
    ThreeYearsVolumeExpectedTableRow,
    ThreeYearsVolumeExpectedTableColumn
  > = {
    keyResolver: (item) => `${item.routePairCode}-${item.year}`,
    disableSorting: true,
    columns: {
      routePairCode: createColumnConfig((item) => item.routePairCode, {
        columnLabel: "",
      }),
      expected: createColumnConfig(
        (item) => dotToCommaTransform(String(item.expected ?? "")),
        {
          columnLabel: "Exp vol.",
          justifyContentHeader: "flex-end",
          justifyContentCell: "flex-end",
        }
      ),
      volume: createColumnConfig(
        (item) => dotToCommaTransform(String(item.volume ?? "")),
        {
          columnLabel: "Vol",
          justifyContentHeader: "flex-end",
          justifyContentCell: "flex-end",
        }
      ),
      expectedMinus1Year: createColumnConfig(
        (item) => dotToCommaTransform(String(item.expectedMinus1Year ?? "")),
        {
          columnLabel: "Exp vol.",
          justifyContentHeader: "flex-end",
          justifyContentCell: "flex-end",
        }
      ),
      volumeMinus1Year: createColumnConfig(
        (item) => dotToCommaTransform(String(item.volumeMinus1Year ?? "")),
        {
          columnLabel: "Vol",
          justifyContentHeader: "flex-end",
          justifyContentCell: "flex-end",
        }
      ),
      expectedMinus2Year: createColumnConfig(
        (item) => dotToCommaTransform(String(item.expectedMinus2Year ?? "")),
        {
          columnLabel: "Exp vol.",
          justifyContentHeader: "flex-end",
          justifyContentCell: "flex-end",
        }
      ),
      volumeMinus2Year: createColumnConfig(
        (item) => dotToCommaTransform(String(item.volumeMinus2Year ?? "")),
        {
          columnLabel: "Vol",
          justifyContentHeader: "flex-end",
          justifyContentCell: "flex-end",
        }
      ),
    },
    columnGroups: {
      routeCode: {
        label: "",
        columnOrder: ["routePairCode"],
      },
      yearMinus2: {
        render(config) {
          return renderHeadingCenter(config.label);
        },
        label: String(year - 2),
        columnOrder: ["expectedMinus2Year", "volumeMinus2Year"],
        borderLeft: true,
      },
      yearMinus1: {
        render(config) {
          return renderHeadingCenter(config.label);
        },
        label: String(year - 1),
        columnOrder: ["expectedMinus1Year", "volumeMinus1Year"],
        borderLeft: true,
      },
      year: {
        render(config) {
          return renderHeadingCenter(config.label);
        },
        label: String(year),
        columnOrder: ["expected", "volume"],
        borderLeft: true,
      },
    },
    columnGroupOrder: ["routeCode", "yearMinus2", "yearMinus1", "year"],
  };
  return threeYearsVolumeExpectedTableConfig;
};
